import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import { Text, Loader } from 'wix-style-react';

import { FadeUp } from '@wix/branding-client-lib';
import Name from '../../Name';
import s from './NamesContainer.scss';

class NamesContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { namesList: currentNamesList, currentIndexIsOpen: currentCurrentIndexIsOpen, loading: currentLoadingState } = this.props;
    const { namesList: nextNamesList, currentIndexIsOpen: nextCurrentIndexIsOpen, loading: nextLoadingState } = nextProps;
    return currentNamesList !== nextNamesList || currentCurrentIndexIsOpen !== nextCurrentIndexIsOpen || currentLoadingState !== nextLoadingState;
  }

  render() {
    const { t, namesList, currentIndexIsOpen, onNameLineClicked, onLikeClicked, referralInfo, industry, loading, screenType } = this.props;
    return loading ? (
      <div className={s.loaderContainer}>
        <Loader key="loader" size="medium" />
        <span key="message" className={s.loaderMassage}>
          <Text> {t('GENERATING_NAMES_MESSAGE')}</Text>
        </span>
      </div>
    ) : (
      <div className={s.namesContainer}>
        {namesList.map((nameData, index) => {
          const { text, isLiked, domain } = nameData;
          const industryText = industry ? industry.industryText : '';
          return (
            <TransitionGroup key={`${index}transition`} component="div" className={s.namesContainer}>
              <FadeUp key={index + 'fade'} delay={index < 10 ? 100 * index : 1000}>
                <Name
                  key={`${index} ${text}`}
                  industryText={industryText}
                  name={text}
                  isLiked={isLiked}
                  t={t}
                  index={index}
                  onNameLineClicked={onNameLineClicked}
                  onLikeClicked={onLikeClicked}
                  domain={domain}
                  referralInfo={referralInfo}
                  expand={index === currentIndexIsOpen}
                  screenType={screenType}
                />
              </FadeUp>
            </TransitionGroup>
          );
        })}
      </div>
    );
  }
}

export default NamesContainer;
